/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import devicePacketsFieldsetTemplate from './device-packets-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */
import './packets.scss';

/* eslint-enable import/no-unresolved, import/default */

const MAX_NUM_OF_PACKETS = 500;

/*@ngInject*/
export default function DevicePacketsDirective($compile, $templateCache, $q, $mdMedia, $filter, $translate, types, deviceService, importExport) {
    var linker = function (scope, element) {
        var template = $templateCache.get(devicePacketsFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.statsQuery = {
            limit: 15,
            page: 1,
            search: null,
        };

	scope.timewindow = {
            history: {
                timewindowMs: 24 * 60 * 60 * 1000 // 1 day
            }
        }

        scope.statsRowsCount = 0;
        scope.isLastElementViewed = false;
        scope.totalResponseArray = [];

        scope.statsLimitOptions =
        [15, 30, 45];

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
            if (scope.isGtMd) {
                scope.statsLimitOptions = [15, 30, 45];
            } else {
                scope.statsLimitOptions = null;
            }
        });

        scope.$watch('deviceId.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    resetTimeWindow();
                    onPageChange();
                }
            }
        });

        scope.$watch("timewindow", function (newVal, prevVal) {
            if (newVal && !angular.equals(newVal, prevVal)) {
                reset();
                onPageChange();
            }
        }, true);

        function getTimeFrame() {
            var startTs, endTs;
            if (scope.timewindow.history.timewindowMs) {
                var currentTime = (new Date).getTime();
                startTs = currentTime - scope.timewindow.history.timewindowMs;
                endTs = currentTime;
            } else {
                startTs = scope.timewindow.history.fixedTimewindow.startTimeMs;
                endTs = scope.timewindow.history.fixedTimewindow.endTimeMs;
            }
            return [startTs, endTs];
        }

        scope.$watch("statsQuery.search", function(newVal, prevVal) {
            if (!angular.equals(newVal, prevVal) && scope.statsQuery.search != null) {
                updateDeviceStatsRows();
            }
        });

        scope.enterDeviceStatisticsFilterMode = function () {
            scope.statsQuery.search = '';
        };

        scope.exitDeviceStatisticsFilterMode = function () {
            scope.statsQuery.search = null;
            updateDeviceStatsRows();
        };

        scope.onDeviceStatisticsPaginate = function () {
            onPageChange();
        };

        function getUniquePackages(allPackages, packages) {
            return packages.filter((el) => allPackages.findIndex((p) => (p.ts === el.ts && p.index === el.index)) < 0);
        }

        function updateDeviceStatsSubscription() {
            unsubscribeDeviceStats();
            if (!scope.timewindow.history.fixedTimewindow) {
                createDeviceStatsSubscription();
                    }
        }

        function unsubscribeDeviceStats() {
            if (scope.deviceStatsSubscriptionHandle) {
                scope.deviceStatsSubscriptionHandle();
                scope.deviceStatsSubscriptionHandle = null;
            }
        }

        function onPageChange() {
            let numberOfNeededElements = scope.statsQuery.page * scope.statsQuery.limit;
            let numberOfElementsNotFound = numberOfNeededElements - scope.totalResponseArray.length + 1;
            let startIndex = (scope.statsQuery.page - 1) * scope.statsQuery.limit;
            if (numberOfElementsNotFound > 0 && !scope.isLastElementViewed) {
                const [startTs, endTs] = getTimeFrame();
                scope.loadingPackets = true;
                let lastPresentElement = scope.totalResponseArray.slice(-1).pop();
                let toTs = lastPresentElement ? lastPresentElement.ts : endTs;
                deviceService.getDevicePackagesWithTimeRange(scope.deviceId.id, startTs, toTs, MAX_NUM_OF_PACKETS).then(function (packages) {
                    if (packages.length < MAX_NUM_OF_PACKETS) {
                        scope.isLastElementViewed = true;
                    }
                    let uniquePackages = getUniquePackages(scope.totalResponseArray, packages);
                    if (uniquePackages.length > 0) {
                        let convertedPackages = convertDeviceStats(uniquePackages);
                        scope.totalResponseArray = [...scope.totalResponseArray, ...convertedPackages];
                    }
                        scope.deviceStatsRows = scope.totalResponseArray.slice(startIndex, numberOfNeededElements);
                        scope.statsRowsCount = scope.totalResponseArray.length;
                        scope.loadingPackets = false;
                }, () => {
                    scope.loadingPackets = false;
                })
            } else {
                scope.deviceStatsRows = scope.totalResponseArray.slice(startIndex, numberOfNeededElements);
                scope.statsRowsCount = scope.totalResponseArray.length;
            }
        }

        function reset() {
            scope.totalResponseArray = [];
            scope.statsRowsCount = 0;
            scope.isLastElementViewed = false;
            scope.deviceStatsRows = null;

            updateDeviceStatsSubscription();

            scope.statsQuery.limit = 15;
            scope.statsQuery.page = 1;
            scope.statsQuery.search = null;
        }

        function resetTimeWindow() {
            scope.timewindow = {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            }
        }

        function createDeviceStatsSubscription() {
            scope.deviceStatsSubscriptionHandle = deviceService.subscribeForDeviceStatsData(scope.deviceId.id,
                onDeviceStatsData, onDeviceStatsDataReconnected);
        }

        function onDeviceStatsData(newDeviceStats) {
            scope.$apply(() => {
                if (newDeviceStats && newDeviceStats.length) {
                    let onlyUniqueNewElements = getUniquePackages(scope.totalResponseArray, convertDeviceStats(newDeviceStats));
                    scope.totalResponseArray = [...onlyUniqueNewElements, ...scope.totalResponseArray];
                    onPageChange();
                }
            });
        }

        function onDeviceStatsDataReconnected() {
            scope.$apply(() => {
                onPageChange();
            });
        }

        function isJoin(stat) {
            return stat.messageType == 'Join Request' || stat.messageType == 'Join Accept';
        }

        function isDownlink(stat) {
            return stat.messageType == 'Downlink' || stat.messageType == 'Join Accept';
        }

        function isUplink(stat) {
            return stat.messageType == 'Uplink' || stat.messageType == 'Join Request';
        }

        function isConfirmed(stat) {
            return stat.mtype == types.gatewayMsgType.CONFIRMED_DATA_UP.value || 
                   stat.mtype == types.gatewayMsgType.CONFIRMED_DATA_DOWN.value;
        }

        function isUnconfirmed(stat) {
            return stat.mtype == types.gatewayMsgType.UNCONFIRMED_DATA_UP.value || 
                   stat.mtype == types.gatewayMsgType.UNCONFIRMED_DATA_DOWN.value;
        }

        function convertDeviceStats(deviceStats) {
            for (var i=0;i<deviceStats.length;i++) {
                var row = deviceStats[i];
                if (isJoin(row)) {
                    row.fcntDown = null;
                    row.fcntUp = null;
                }
                if (isUplink(row)) {
                    row.fcntDown = null;
                    row.loRaSNR = parseFloat(row.loRaSNR.toFixed(1));
                } else if (isDownlink(row)) {
                    row.fcntUp = null;
                    row.rssi = null;
                    row.loRaSNR = null;
                }

                if (isConfirmed(row)) {
                    row.confirmed = true;
                } else if (isUnconfirmed(row)) {
                    row.unconfirmed = true;
                }
            }
            return deviceStats;
        }

        function updateDeviceStatsRows() {
            var result = scope.deviceStatsRows;
            if (scope.statsQuery.search != null) {
                result = $filter('filter')(result, {$: scope.statsQuery.search});
            }
            scope.deviceStatsRows = result;
        }


        scope.formatFrequency = function (frequency) {
            var res = '';
            if (angular.isDefined(frequency) && frequency != null) {
                var formatted = Number(frequency);
                formatted = formatted / 1000000;
                formatted = formatted.toFixed(4);
                formatted = (formatted * 1);
                res = formatted.toString();
            }
            return res;
        };

        function getAllPacketsForPeriod() {
            var deferred = $q.defer();

            let isAllPackets = false;
            let allPackets = [];
            const [startTs, endTs] = getTimeFrame();

            let getPackets = function (endTime = endTs) {
                deviceService.getDevicePackagesWithTimeRange(scope.deviceId.id, startTs, endTime, MAX_NUM_OF_PACKETS)
                    .then(function (packages) {
                        if (packages.length < MAX_NUM_OF_PACKETS) {
                            isAllPackets = true;
                        }
                        let uniquePackages = getUniquePackages(allPackets, packages)
                        if (uniquePackages.length > 0) {
                            allPackets = [...allPackets, ...uniquePackages];
                        } else {
                            deferred.resolve(allPackets);
                        }

                        if (isAllPackets) {
                            deferred.resolve(allPackets);
                        } else {
                            let lastPresentElement = uniquePackages.slice(-1).pop();
                            getPackets(lastPresentElement.ts);
                        }
                    })
                    .catch(function () {
                        deferred.reject();
                    });
            }
            getPackets();
            return deferred.promise;
        }

        scope.exportDevicePackets = () => {
            const columnsOrder = ['ts', 'gwMac', 'rssi', 'antenna', 'frequency', 'channel', 'codeRate', 'loRaSNR',
                'spreadFactor', 'bandwidth', 'messageType', 'fport', 'rawPayload', 'fcntUp', 'fcntDown', 'isConfirmed', 'dutyCycled', 'tsUTC'
            ];
            getAllPacketsForPeriod().then(
                (packages) => {
                    const csvData = convertDeviceStats(packages).reduce((acc, stateObject) => {
                        const row = [];
                        columnsOrder.forEach(column => {
                            switch (column) {
                                case 'ts':
                                    row.push($filter('date')(new Date(stateObject[column]), 'yyyy-MM-dd HH:mm:ss'));
                                    break;
                                case 'tsUTC':
                                    row.push($filter('date')(new Date(stateObject['ts']), 'yyyy-MM-dd HH:mm:ss', 'UTC'));
                                    break;
                                case 'frequency':
                                    row.push(scope.formatFrequency(stateObject[column]));
                                    break;
                                case 'isConfirmed':
                                    if (stateObject.confirmed) {
                                        row.push($translate.instant('device.confirmed'))
                                    } else if (stateObject.unconfirmed) {
                                        row.push($translate.instant('device.unconfirmed'))
                                    }
                                    break;
                                default:
                                    row.push(stateObject[column]);
                                    break;
                            }
                        });
                        acc += row.join(';') + '\n';
                        return acc;
                    }, '');
                    importExport.downloadFile(columnsOrder.join(';') + '\n' + csvData, 'real-time-packets', types.fileType.CSV);
            });
        };

        $compile(element.contents())(scope);
    }



    return {
        restrict: "E",
        link: linker,
        scope: {
            deviceId: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/packets/device-packets.directive.js